import React from 'react'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'
import './dataAddress.scss'

const DataAddress = ({ data, onHandleChange, isDisabled }) => {
  return (
    <div className="data-address">
      {/* Datos del centro  */}
      <LabeledText
        idLabel="zone"
        required={!isDisabled}
        name="zone"
        value={data?.zone}
        onChange={onHandleChange}
        disabled={isDisabled}
      />

      <LabeledText
        idLabel="province"
        required={!isDisabled}
        name="province"
        value={data?.province}
        onChange={onHandleChange}
        disabled={isDisabled}
      />

      <LabeledText
        idLabel="locality"
        required={!isDisabled}
        name="locality"
        value={data?.locality}
        onChange={onHandleChange}
        disabled={isDisabled}
      />

      <LabeledText
        idLabel="postalCode"
        required={!isDisabled}
        name="cp"
        value={data?.cp}
        onChange={onHandleChange}
        disabled={isDisabled}
      />

      <LabeledText
        idLabel="address"
        required={!isDisabled}
        name="address"
        value={data?.address}
        onChange={onHandleChange}
        disabled={isDisabled}
      />
    </div>
  )
}

export default DataAddress
